var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnsubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_8360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0002 0.833496C4.94546 0.833496 0.833496 4.94546 0.833496 10.0002C0.833496 15.0549 4.94546 19.1668 10.0002 19.1668C15.0549 19.1668 19.1668 15.0549 19.1668 10.0002C19.1668 4.94546 15.0549 0.833496 10.0002 0.833496ZM14.0106 10.764H5.98975C5.56804 10.764 5.2259 10.4219 5.2259 10.0002C5.2259 9.57846 5.56804 9.23632 5.98975 9.23632H14.0106C14.4323 9.23632 14.7744 9.57846 14.7744 10.0002C14.7744 10.4219 14.4323 10.764 14.0106 10.764Z",
    fill: "#EE4D4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_8360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribe);
export default __webpack_public_path__ + "static/media/Unsubscribe.caa7470f9e197a218f09a6e0733c51bc.svg";
export { ForwardRef as ReactComponent };